import { StarterPackCardView, StarterPackView } from '@zola/svc-marketplace-ts-types';

import { createAction } from '@reduxjs/toolkit';

const RECEIVED_STARTER_PACK = 'zola/couplesInquiries/RECEIVED_STARTER_PACK';
const UPDATED_STARTER_PACK_CARD = 'zola/couplesInquiries/UPDATED_STARTER_PACK_CARD';

export const receivedStarterPack = createAction<StarterPackView>(RECEIVED_STARTER_PACK);
export const updatedStarterPackCard = createAction<StarterPackCardView>(UPDATED_STARTER_PACK_CARD);
